module.exports = __webpack_public_path__ + "static/media/art40.4e24a8ad.jpg";